<template>
  <div>
    <div class="hero-header">
      <img :src="head_about" width="100%" fetchpriority="high" class="fade-in"></img>
      <div class="hero-overlay">
        <p>关于我们</p>
      </div>
    </div>
    <div class="content">
      <img :src="floor" loading="lazy" class="fade-in about-img"/>
      <div class="desc">
        <p class="f-s-32 f-bolder f-lh-2">上海同儒信息技术有限公司</p>
        <p class="f-s-24">(简称：同儒信息)</p>
        <el-divider></el-divider>
        <p class="f-lh-2">
          上海同儒信息技术有限公司是一家为中小银行数字化建设提供一站式服务平台的供应商，通过将大数据、人工智能、互联网等技术与中小银行业务相结合，在数据治理、业务建模、精准营销、流程优化和员工赋能等领域为中小银行提供全局化的建设思路及“咨询+IT”一体化的解决方案，助力中小银行转型升级。
        </p>
        <div class="culture">
          <div class="item">
            <concept-sharing theme="outline" size="32" fill="#ff976a" class="icon" :strokeWidth="2"/>
            <div>
              <p class="f-s-18 f-bolder">使命</p>
              <p>赋能中小银行，助力智能升级</p>
            </div>
          </div>
          <div class="item">
            <send theme="outline" size="32" fill="#ff976a" class="icon" :strokeWidth="2"/>
            <div>
              <p class="f-s-18 f-bolder">愿景</p>
              <p>成为国内领先的中小银行智能升级服务商</p>
            </div>
          </div>
          <div class="item">
            <diamonds theme="outline" size="32" fill="#ff976a" class="icon" :strokeWidth="2"/>
            <div>
              <p class="f-s-18 f-bolder">价值观</p>
              <p>敏捷 创新 突破 极致</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section-header">
      <p class="section-title">公司资质</p>
    </div>
    <div class="certs">
      <el-row>
        <el-col :span="4">
          <img :src="iso9001" width="180" height="120" loading="lazy" class="fade-in cert-img" @click="openPreview(iso9001)"/>
        </el-col>
        <el-col :span="4">
          <img :src="iso27001" width="180" height="120" loading="lazy" class="fade-in cert-img" @click="openPreview(iso27001)"/>
        </el-col>
        <el-col :span="4">
          <img :src="gaoxin" width="180" height="120" loading="lazy" class="fade-in cert-img" @click="openPreview(gaoxin)"/>
        </el-col>
        <el-col :span="4" >
          <img :src="rjcp" width="180" height="120" loading="lazy" class="fade-in cert-img" @click="openPreview(rjcp)"/>
        </el-col>
        <el-col :span="4">
          <img :src="rjqy" width="180" height="120" loading="lazy" class="fade-in cert-img" @click="openPreview(rjqy)"/>
        </el-col>
      </el-row>
    </div>
    <div class="section-header">
      <p class="section-title">软件著作权</p>
    </div>
    <div class="copyright-section">
      <img :src="jx" loading="lazy" class="fade-in copyright-img"/>
      <div class="desc">
        <p class="f-s-24 f-grey-7">拥有四十余项软件著作权</p>
        <ul>
          <li class="f-grey-7">普惠金融服务点信息管理系统</li>
          <li class="f-grey-7">数据调度平台</li>
          <li class="f-grey-7">再造信贷业务管理系统</li>
          <li class="f-grey-7">费用预算管理系统</li>
          <li class="f-grey-7">资金营运管理系统</li>
          <li class="f-grey-7">综合办公管理系统</li>
          <li class="f-grey-7">移动办公工作平台</li>
          <li class="f-grey-7">物资管理系统</li>
          <li class="f-grey-7">商业银行流程化业务管理软件</li>
          <li class="f-grey-7">绩效考核管理系统</li>
          <li class="f-grey-7">人力资源管理系统</li>
          <li class="f-grey-7">客户精准营销管理软件</li>
          <li class="f-grey-7">客户积分管理软件</li>
          <li class="f-grey-7">客户服务中心软件</li>
          <li class="f-grey-7">基于大数据的客户分层分类管理软件</li>
          <li class="f-grey-7">网格化营销管理系统软件</li>
          <li class="f-grey-7">积分商城软件</li>
          <li class="f-grey-7">综合数字化应用平台软件</li>
          <li class="f-grey-7">私域营销管理系统软件</li>
          <li class="f-grey-7">金色年华会员权益管理系统软件</li>
          <li class="f-grey-7">数字可视化看板软件</li>
          <li class="f-grey-7">综合报表平台软件</li>
          <li class="f-grey-7">信贷档案电子化管理系统软件</li>
          <li class="f-grey-7">数据资产管理平台软件</li>
          <li class="f-grey-7">普惠走访系统软件</li>
          <li class="f-grey-7">一码通商户管理系统软件</li>
          <li class="f-grey-7">不良资产管理系统软件</li>
          <li class="f-grey-7">信贷辅助管理系统软件</li>
          <li class="f-grey-7">贷后管理系统软件</li>
          <li class="f-grey-7">贷款风险责任制管理系统软件</li>
          <li class="f-grey-7">商户管理系统</li>
          <li class="f-grey-7">对公客户管理系统</li>
          <li class="f-grey-7">数据仓库系统</li>
          <li class="f-grey-7">员工行为风险管理系统</li>
          <li class="f-grey-7">制度库智能检索与学习平台</li>
          <li class="f-grey-7">OKR管理系统</li>
          <li class="f-grey-7">私域流量运营与转化数字平台</li>
          <li class="f-grey-7">数字化薪酬管理与智能分析系统</li>
          <li class="f-grey-7">数字化信贷辅助管理系统</li>
          <li class="f-grey-7">智能化贷后风控管理系统</li>
          <li class="f-grey-7">智能外呼营销管理系统</li>
        </ul>
      </div>
    </div>
    <div v-if="previewVisible" class="preview-overlay" @click="closePreview">
      <div class="preview-close" @click="closePreview">✕</div>
      <img :src="previewSrc" class="preview-img" @click.stop/>
    </div>
  </div>
</template>

<script>
  import { ConceptSharing, Send, Diamonds } from '@icon-park/vue'
  
  export default {
    components: { ConceptSharing, Send, Diamonds },
    data() {
      return {
        head_about: require('@/assets/head_floor.jpg'),
        floor: require('@/assets/floor.png'),
        gaoxin: require('./certs/gaoxin.jpg'),
        rjcp: require('./certs/rjcp.jpg'),
        rjqy: require('./certs/rjqy.jpg'),
        iso9001: require('./certs/iso9001.jpg'),
        iso27001: require('./certs/iso27001.jpg'),
        jx: require('./certs/jx.jpg'),
        previewVisible: false,
        previewSrc: ''
      }
    },
    methods: {
      openPreview(src) {
        this.previewSrc = src
        this.previewVisible = true
      },
      closePreview() {
        this.previewVisible = false
        this.previewSrc = ''
      }
    }
  }
</script>

<style lang="less" scoped>
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .fade-in {
    animation: fadeIn 0.6s ease-out forwards;
  }

  .hero-header {
    position: relative;

    img {
      display: block;
    }

    .hero-overlay {
      position: absolute;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(180deg, rgba(20, 28, 46, 0.2) 0%, rgba(20, 28, 46, 0.6) 100%);

      p {
        font-size: 40px;
        font-weight: 800;
        color: #fff;
        letter-spacing: 4px;
        text-shadow: 0 2px 16px rgba(0, 0, 0, 0.3);
      }
    }
  }

  .cert-img {
    background: #f5f5f5;
    border-radius: 8px;
  }

  .content {
    padding: 80px 8%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    img {
      border-radius: 16px;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.06);
    }

    .about-img {
      max-width: 400px;
      width: 100%;
      height: auto;
      object-fit: contain;
    }

    .desc{
      flex: 1;
      padding: 20px 60px;
      min-width: 300px;

      & > p:first-child {
        background: linear-gradient(135deg, #1a56b8 0%, #174291 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }

      .el-divider {
        margin: 20px 0;
      }

      p.f-lh-2 {
        font-size: 16px;
        line-height: 2;
        color: #4b5563;
      }
    }

    .culture {
      padding: 30px 0;
      display: flex;
      gap: 16px;

      .item {
        flex: 1;
        display: flex;
        align-items: center;
        padding: 20px 16px;
        background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
        border-radius: 14px;
        border: 1px solid rgba(26, 86, 184, 0.06);
        transition: all 0.35s ease;

        &:hover {
          background: #fff;
          box-shadow: 0 8px 28px rgba(26, 86, 184, 0.1);
          transform: translateY(-2px);
          border-color: rgba(26, 86, 184, 0.15);
        }

        .icon {
          margin-right: 14px;
          flex-shrink: 0;
        }

        p:first-of-type {
          font-size: 15px;
          font-weight: 700;
          color: #1f2937;
          margin-bottom: 4px;
        }

        p:last-of-type {
          font-size: 13px;
          color: #6b7280;
          line-height: 1.5;
        }
      }
    }
  }

  .section-header {
    text-align: center;
    padding: 40px 0 10px;

    .section-title {
      font-size: 32px;
      font-weight: 700;
      color: #1f2937;
      position: relative;
      display: inline-block;
      padding-bottom: 16px;

      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 50px;
        height: 3px;
        background: linear-gradient(90deg, #1a56b8 0%, #3b82f6 100%);
        border-radius: 2px;
      }
    }
  }

  .certs {
    padding: 50px 8% 60px;

    .el-row {
      display: flex;
      justify-content: center;
      gap: 20px;
      flex-wrap: wrap;
    }

    .el-col {
      padding: 5px;
      display: flex;
      justify-content: center;
      width: auto;
      flex: none;

      img {
        width: 160px;
        height: 110px;
        object-fit: contain;
        cursor: pointer;
        transition: all 0.35s ease;
        background: #fff;
        border-radius: 12px;
        padding: 8px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
        border: 1px solid #f1f5f9;

        &:hover {
          transform: scale(1.08) translateY(-4px);
          box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);
        }
      }
    }
  }

  .el-divider--horizontal {
    ::v-deep .el-divider__text {
      display: none;
    }
  }

  .copyright-section {
    padding: 60px 8% 80px;
    display: flex;
    align-items: flex-start;
    gap: 60px;

    img {
      border-radius: 16px;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.06);
      flex-shrink: 0;
    }

    .copyright-img {
      max-width: 400px;
      width: 100%;
      height: auto;
      object-fit: contain;
    }

    .desc {
      flex: 1;

      & > p {
        font-size: 16px;
        font-weight: 600;
        color: #374151;
        margin-bottom: 28px;
        position: relative;
        padding-left: 14px;

        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 2px;
          bottom: 2px;
          width: 3px;
          background: linear-gradient(180deg, #1a56b8 0%, #3b82f6 100%);
          border-radius: 2px;
        }
      }

      ul {
        list-style: none;
        padding: 0;
        margin: 0;
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
        gap: 14px 24px;

        li {
          position: relative;
          padding: 12px 16px 12px 32px;
          background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
          border-radius: 10px;
          font-size: 14px;
          color: #4b5563;
          transition: all 0.25s ease;
          border: 1px solid transparent;

          &::before {
            content: '';
            position: absolute;
            left: 14px;
            top: 50%;
            transform: translateY(-50%);
            width: 6px;
            height: 6px;
            background: #1a56b8;
            border-radius: 50%;
          }

          &:hover {
            background: #fff;
            border-color: rgba(26, 86, 184, 0.2);
            box-shadow: 0 4px 12px rgba(26, 86, 184, 0.08);
            transform: translateX(4px);
          }
        }
      }
    }
  }

  .preview-overlay {
    position: fixed;
    inset: 0;
    z-index: 9999;
    background: rgba(0, 0, 0, 0.85);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: zoom-out;
    animation: fadeIn 0.25s ease;

    .preview-close {
      position: absolute;
      top: 24px;
      right: 24px;
      width: 44px;
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      color: #fff;
      background: rgba(255, 255, 255, 0.15);
      border-radius: 50%;
      cursor: pointer;
      transition: all 0.25s ease;
      z-index: 1;

      &:hover {
        background: rgba(255, 255, 255, 0.3);
        transform: scale(1.1);
      }
    }

    .preview-img {
      max-width: 90vw;
      max-height: 85vh;
      object-fit: contain;
      border-radius: 8px;
      box-shadow: 0 16px 48px rgba(0, 0, 0, 0.4);
      cursor: default;
    }
  }

  @media (max-width: 768px) {
    .content {
      padding: 40px 5%;
      flex-direction: column;

      .desc {
        padding: 20px 0;
      }
    }

    .culture {
      flex-direction: column;
    }

    .hero-header .hero-overlay p {
      font-size: 24px;
    }

    .copyright-section {
      padding: 40px 5%;
      flex-direction: column;
      gap: 30px;

      ul {
        grid-template-columns: 1fr;
      }
    }
  }
</style>
